var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"rigthTop"}},[_c('div',{staticClass:"lb-title"},[_vm._v("岗位分布就业人数")]),_c('dv-capsule-chart',{staticClass:"lb-content",attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }